/* Source: /home/sidsolaiyappan/skooch_ai/shared/optimize_hints.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function recordOptimizeHints(inputTotal, placements, overflow, suggestions, logText, schedulerTasks, fBlocks, devActive) {
  try {
    window.__skoochLastOptimizeInputTotal = inputTotal;
  } catch (__jac_e) {
    if (true) {
      let _e0 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastPlacementRows = placements.length;
  } catch (__jac_e) {
    if (true) {
      let _e1 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastPlacements = placements;
  } catch (__jac_e) {
    if (true) {
      let _e2 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastOverflow = overflow;
  } catch (__jac_e) {
    if (true) {
      let _e3 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSuggestions = suggestions;
  } catch (__jac_e) {
    if (true) {
      let _e4 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSchedLog = logText;
  } catch (__jac_e) {
    if (true) {
      let _e5 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSchedulerTasks = schedulerTasks;
  } catch (__jac_e) {
    if (true) {
      let _e6 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastFixedBlocks = fBlocks;
  } catch (__jac_e) {
    if (true) {
      let _e7 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastDevActive = devActive;
  } catch (__jac_e) {
    if (true) {
      let _e8 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function clearOptimizeHints() {
  try {
    window.__skoochLastOptimizeInputTotal = 0;
  } catch (__jac_e) {
    if (true) {
      let _e0 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastPlacementRows = 0;
  } catch (__jac_e) {
    if (true) {
      let _e1 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastPlacements = [];
  } catch (__jac_e) {
    if (true) {
      let _e2 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastOverflow = [];
  } catch (__jac_e) {
    if (true) {
      let _e3 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSuggestions = [];
  } catch (__jac_e) {
    if (true) {
      let _e4 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSchedLog = "";
  } catch (__jac_e) {
    if (true) {
      let _e5 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastSchedulerTasks = [];
  } catch (__jac_e) {
    if (true) {
      let _e6 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastFixedBlocks = [];
  } catch (__jac_e) {
    if (true) {
      let _e7 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastDevActive = false;
  } catch (__jac_e) {
    if (true) {
      let _e8 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function recordDevScenarioHints(schedulerTasks, fBlocks) {
  try {
    window.__skoochLastSchedulerTasks = schedulerTasks;
  } catch (__jac_e) {
    if (true) {
      let _e0 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastFixedBlocks = fBlocks;
  } catch (__jac_e) {
    if (true) {
      let _e1 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochLastDevActive = true;
  } catch (__jac_e) {
    if (true) {
      let _e2 = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function setLastDevActive(active) {
  try {
    window.__skoochLastDevActive = active;
  } catch (__jac_e) {
    if (true) {
      let _e = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function computePreserveLocalDecision(localScheduleLen, schOptimized, schOptimizeInputTotal) {
  let _wi = window.__skoochLastOptimizeInputTotal;
  if ((_wi === undefined)) {
    _wi = 0;
  }
  let _wr = window.__skoochLastPlacementRows;
  if ((_wr === undefined)) {
    _wr = 0;
  }
  let _effIn = ((_wi > schOptimizeInputTotal) ? _wi : schOptimizeInputTotal);
  let _recent = (((_effIn > 0) || (_wr > 0)) || schOptimized);
  let _preserve = ((localScheduleLen > 0) || _recent);
  return {"effIn": _effIn, "placementRowsMirror": _wr, "recent": _recent, "preserve": _preserve};
}
function readOptimizeHydrationCache() {
  let _lp = window.__skoochLastPlacements;
  let _wr = window.__skoochLastPlacementRows;
  let _ov = window.__skoochLastOverflow;
  let _sg = window.__skoochLastSuggestions;
  let _lt = window.__skoochLastSchedLog;
  let _it = window.__skoochLastOptimizeInputTotal;
  let _st = window.__skoochLastSchedulerTasks;
  let _fb = window.__skoochLastFixedBlocks;
  return {"placements": ((_lp !== undefined) ? _lp : []), "placementRows": ((_wr !== undefined) ? _wr : 0), "overflow": ((_ov !== undefined) ? _ov : []), "suggestions": ((_sg !== undefined) ? _sg : []), "log": ((_lt !== undefined) ? _lt : ""), "inputTotal": ((_it !== undefined) ? _it : 0), "schedulerTasks": ((_st !== undefined) ? _st : []), "fixedBlocks": ((_fb !== undefined) ? _fb : [])};
}
export {clearOptimizeHints, computePreserveLocalDecision, readOptimizeHydrationCache, recordDevScenarioHints, recordOptimizeHints, setLastDevActive};
//# sourceMappingURL=optimize_hints.js.map
